/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationResult
 */
export interface InvitationResult {
    /**
     * 
     * @type {string}
     * @memberof InvitationResult
     */
    inviteeName: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResult
     */
    projectName: string;
    /**
     * 
     * @type {string}
     * @memberof InvitationResult
     */
    role: InvitationResultRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof InvitationResult
     */
    isAcceptedByYou?: boolean;
}

export function InvitationResultFromJSON(json: any): InvitationResult {
    return {
        'inviteeName': json['inviteeName'],
        'projectName': json['projectName'],
        'role': json['role'],
        'isAcceptedByYou': !exists(json, 'isAcceptedByYou') ? undefined : json['isAcceptedByYou'],
    };
}

export function InvitationResultToJSON(value?: InvitationResult): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'inviteeName': value.inviteeName,
        'projectName': value.projectName,
        'role': value.role,
        'isAcceptedByYou': value.isAcceptedByYou,
    };
}

/**
* @export
* @enum {string}
*/
export enum InvitationResultRoleEnum {
    Admin = 'Admin'
}


